import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../utils/queryParams";
import { getIds } from "../../../utils/getIds";
import { API_DATE_FORMAT } from "../../../app_constants";

export const SET_LOADING = "./BrandLeaderBoard/SET_LOADING";
export const FETCH_CURRENT_USER = "./BrandLeaderBoard/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "./BrandLeaderBoard/FETCH_CURRENT_USER_SUCCESS";
export const RESET_FILTER_SELECTED = "./BrandLeaderBoard/RESET_FILTER_SELECTED";
export const SET_DATES = "./BrandLeaderBoard/SET_DATES";
export const UPDATE_DATES = "./BrandLeaderBoard/UPDATE_DATES";
export const RESET_FILTER = "./BrandLeaderBoard/RESET_FILTERS";
export const UPDATE_VIEW_FILTER = "./BrandLeaderBoard/UPDATE_VIEW_FILTER";
export const UPDATE_TABLE_DATA = "./BrandLeaderBoard/UPDATE_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "./BrandLeaderBoard/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "./BrandLeaderBoard/FETCH_FILTERS_SUCCESS";
export const SET_SELECTED_METRICS = "./BrandLeaderBoard/SET_SELECTED_METRICS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateView: createAction(UPDATE_VIEW_FILTER),
  updateTableData: createAction(UPDATE_TABLE_DATA),
  updateDates: createAction(UPDATE_DATES),
  resetFilters: createAction(RESET_FILTER),
  updateSelectedMetricsFilter: createAction(SET_SELECTED_METRICS)
};

export default function* watchBrandLeaderBoard() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_TABLE_DATA, fetchTableData);
  yield takeLatest(RESET_FILTER, resetFilters);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  let dates = yield getDatesHelper();
  yield setDates(...dates);
  try {
    yield getFilters();
    yield fetchTableData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: SET_LOADING, payload: false });
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  return yield select((state) => {
    const {
      selectedRequestDates: { startDate, endDate },
      selectedMetrics
    } = state.brandLeaderboard;

    return {
      organization_id,
      short_url,
      startDate,
      endDate,
      metrics: getIds(selectedMetrics)
    };
  });
}

export function* fetchTableData() {
  yield put({ type: SET_LOADING, payload: true });

  const { organization_id, short_url, startDate, endDate, metrics } = yield getCommonApiParams();
  const { selectedViewOption } = yield select((state) => state.brandLeaderboard);

  const params = {
    organization_id,
    short_url,
    end_date: endDate,
    start_date: startDate,
    view_type: selectedViewOption.name.toLowerCase(),
    metrics
  };

  const url = queryParams.apiVersion + "/pages/brand_leaderboard/brand_leaderboard_page";

  try {
    let { data } = yield call(axios.get, url, { params });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: data });
    yield put({ type: SET_LOADING, payload: false });
  } catch (err) {
    console.error(err);
    yield put({ type: SET_LOADING, payload: false });
  }
}

export function* setDates(startDate, endDate) {
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

export function* getFilters() {
  const { short_url } = yield getCommonApiParams();
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "/pages/brand_leaderboard/brand_leaderboard_page/get_filters" +
        "?short_url=" +
        short_url
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  let dates = yield getDatesHelper();
  yield setDates(...dates);
  yield put({ type: RESET_FILTER_SELECTED });
  try {
    yield getFilters();
    yield fetchTableData();
  } catch (error) {
    console.error(error);
  }
}

function* getDatesHelper() {
  const endDate = yield select((state) => state.brandLeaderboard.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").format(API_DATE_FORMAT);
  return [startDate, endDate];
}
